// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDblbwglNFi5ZJMmYc3l_G_3HK7NzgbpFw",
  // authDomain: "kiwe-app-468f9.firebaseapp.com",
  authDomain: "kw.biotinc.com",
  projectId: "kiwe-app-468f9",
  storageBucket: "kiwe-app-468f9.firebasestorage.app",
  messagingSenderId: "266639702025",
  appId: "1:266639702025:web:0f0949973d44c6543960d8",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
